import React, { useContext, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import Banner from '../components/Banner';
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import { YachtContext } from '../context/YachtContext';
import BookNowButton from '../components/BookNowButton';

const YachtDetails = () => {
    const { fetchYachtDetails, yachtError, yachtLoading, yacht } = useContext(YachtContext);
    const { id } = useParams(); // Grab the yacht id from the URL

    useEffect(() => {

        fetchYachtDetails(id);  // Fetch yacht details only if not loaded or if id has changed

    }, [fetchYachtDetails]); // This effect runs when `id` or `yacht` changes

    // Display loading or error states
    if (yachtLoading) return <div className="d-flex justify-content-center align-items-center" style={{ minHeight: '50vh' }}>
        <div className="spinner-border text-dark" role="status">
            <span className="visually-hidden">Loading...</span>
        </div>
    </div>;
    // if (yachtError) return <div>{yachtError}</div>;

    return (
        <main id="yacht-details">
            {yacht && (
                <>
                    <Banner img={yacht.preview_url || "https://images.pexels.com/photos/237289/pexels-photo-237289.jpeg?auto=compress&amp;cs=tinysrgb&amp;w=1260&amp;h=750&amp;dpr=1"}
                        text={yacht.yacht_name || "Yacht Name"} />

                    <section className="yacht-details-section gap">
                        <div className="container">
                            <div className="row gx-5">
                                <div className="col-lg-8">
                                    <Swiper className="swiper-container" loop={true} modules={[Navigation]} navigation>
                                        {yacht.images && yacht.images.map((image, index) => (
                                            <SwiperSlide key={index}>
                                                <img src={image.image} className="card-img-top" alt={`Boat ${index + 1}`} />
                                            </SwiperSlide>
                                        ))}
                                    </Swiper>

                                </div>

                                <div className="col-lg-4 side-contain">
                                    <h2 className="mb-3">{yacht.yacht_name}</h2>

                                    <div className="specs-container">
                                        <div className="spec-item">
                                            <span className="label">Brand</span>
                                            <span className="value">{yacht.brand}</span>
                                        </div>
                                        <div className="spec-item">
                                            <span className="label">Size</span>
                                            <span className="value">{yacht.size} </span>
                                        </div>
                                        <div className="spec-item">
                                            <span className="label">Capacity</span>
                                            <span className="value">{yacht.passenger_capacity}</span>
                                        </div>
                                        <div className="spec-item">
                                            <span className="label">Price</span>
                                            <span className="value">{yacht.price_per_hour} AED</span>
                                        </div>
                                        <div className="spec-item">
                                            <span className="label">Special Price</span>
                                            <span className="value">{yacht.special_price} AED</span>
                                        </div>
                                        <div className="spec-item">
                                            <span className="label">Amenities</span>
                                            <span className="value" dangerouslySetInnerHTML={{ __html: yacht.amenities }}></span>
                                        </div>
                                        <div className="spec-item">
                                            <span className="label">Additional Information</span>
                                            <span className="value" dangerouslySetInnerHTML={{ __html: yacht.additional_information }}></span>
                                        </div>
                                        <br />
                                        <BookNowButton buttonText="Book Yacht" buttonClass="book-btn" yachtId={yacht.id} yachtName={yacht.yacht_name} />
                                        {/* <div className="spec-item">
                                            <span className="label">Toys</span>
                                           
                                        </div> */}
                                    </div>




                                </div>
                                <div className="col-12">

                                    <h3 className='mt-4'>
                                        Additional Information
                                    </h3>

                                    <div className='my-4' dangerouslySetInnerHTML={{ __html: yacht.description }} />
                                    {/* <button className="book-btn">Book Yacht</button> */}

                                    <BookNowButton buttonText="Book Yacht" buttonClass="book-btn" yachtId={yacht.id} yachtName={yacht.yacht_name} />

                                </div>
                            </div>
                        </div>
                    </section>
                </>
            )}
        </main>
    );
}

export default YachtDetails;
